import { Button, Form, Row, Space, theme } from "antd";
import FormItem from "../../form/form-item";
import { useCallback, useEffect } from "react";
import { useGetSalariesQuery } from "../../../../api/plamo-api";
import PlamoApiWithSaveNotifications from "../../util/with-save-notification";

import { DeleteOutlined } from "@ant-design/icons";
import { AdvancedForm, useAdvancedFormContext } from "../../form/advanced-form";

const { useCreateSalaryWithSaveNotificationMutation, useUpdateSalaryWithSaveNotificationMutation, useDeleteSalaryWithSaveNotificationMutation } = PlamoApiWithSaveNotifications;


const AddSalaryButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button onClick={onClick} disabled={advancedFormContext.readOnly}>
      Neues Gehalt hinzufügen
    </Button>
  )
}

const DeleteButton = ({ onClick }) => {
  const advancedFormContext = useAdvancedFormContext()

  return (
    <Button icon={<DeleteOutlined />} onClick={onClick} disabled={advancedFormContext.readOnly} />
  )
}

function EmployeeSalaries({ employeeId }) {
  const [form] = Form.useForm();
  const { data } = useGetSalariesQuery({ f: JSON.stringify({ "employee.id": { c: "EQ", v: employeeId }}), st: JSON.stringify({ id: 'asc' }) }) as any
  const [ createSalary, { isLoading: isCreatingSalary } ] = useCreateSalaryWithSaveNotificationMutation();
  const [ updateSalary, { isLoading: isUpdatingSalary } ] = useUpdateSalaryWithSaveNotificationMutation();
  const [ deleteSalary, { isLoading: isDeletingSalary } ] = useDeleteSalaryWithSaveNotificationMutation();
  //const relatives = useMemo(() => data.items || [], [data])

  const isLoading = isCreatingSalary || isUpdatingSalary || isDeletingSalary;

  const { token } = theme.useToken();

  const formStyle: React.CSSProperties = {
    maxWidth: 'none',
    background: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    padding: 24,
  };

  useEffect(() => {
      form.setFieldsValue(data)
  }, [form, data])

  const onFinish = useCallback(async (values: any) => {
    console.log('On finish', values);
    const promisesCreateUpdate = values.items.map(i => {
      if(i.id) {
        return updateSalary(i);
      } else {
        return createSalary(i);
      }
    })

    const promisesDelete = data.items.filter(i => !values.items.find(i2 => i.id === i2.id)).map(i => deleteSalary(i));
    
    await Promise.all([...promisesCreateUpdate, ...promisesDelete]);
  }, [createSalary, updateSalary, deleteSalary, data]);

  return (<AdvancedForm form={form} name="salaries" style={formStyle} onFinish={onFinish} originalValues={data} isLoading={isLoading}>
    <Form.List name="items">
      {(fields, { add, remove }, { errors }) => <>{
        fields.map((field, index) => { return <>
          <Row><h3>Gehalt { index + 1 } <DeleteButton  onClick={() => remove(index)} /></h3></Row>
          <Row gutter={24}>
            <FormItem field={field} fieldName="jobType" label="Funktion" type="backendEnum" typeData={{ showSearch: true, ident: "jobType" }} />
            <FormItem field={field} fieldName="salaryPerHour" label="Stundenlohn" type="currency" />
            <FormItem field={field} fieldName="startDate" label="Ab" type="date" />
            <FormItem field={field} fieldName="endDate" label="Bis" type="date" />
          </Row>
        </>})}
        <div style={{ textAlign: 'right', marginBottom: '24px' }}>
          <Space size="small">
            <AddSalaryButton onClick={() => add({ employeeId })} />
          </Space>
        </div>
        </>
      }
    </Form.List> 
    </AdvancedForm>)
}

export default EmployeeSalaries